import * as React from 'react';
import { AlignPluginOptions } from './types';
import { RenderElementProps } from 'slate-react';
import { isElementWithType } from '../../../figma/DolEditor/helpers/node-filter';
import {
  ELEMENT_ALIGN_CENTER,
  ELEMENT_ALIGN_JUSTIFY,
  ELEMENT_ALIGN_LEFT,
  ELEMENT_ALIGN_RIGHT,
} from './defaults';

/**
 * Enables support for text alignment, useful to align your content
 * to left, right and center it.
 */
export const AlignReadOnlyPlugin = (options?: AlignPluginOptions) => ({
  renderElement: ({ element, children }: RenderElementProps) => {
    if (isElementWithType(element, ELEMENT_ALIGN_LEFT)) {
      return <div style={{ textAlign: 'left' }}>{children}</div>;
    }

    if (isElementWithType(element, ELEMENT_ALIGN_CENTER)) {
      return <div style={{ textAlign: 'center' }}>{children}</div>;
    }

    if (isElementWithType(element, ELEMENT_ALIGN_RIGHT)) {
      return <div style={{ textAlign: 'right' }}>{children}</div>;
    }

    if (isElementWithType(element, ELEMENT_ALIGN_JUSTIFY)) {
      return <div style={{ textAlign: 'justify' }}>{children}</div>;
    }

    return undefined;
  },
});
